import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import AddBox from "@material-ui/icons/AddBox";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    check: {}
}), { name: "DployTableIcons" });
export const tableIcons = {
    Add: forwardRef((props, ref) => (_jsx(AddBox, { ...props, ref: ref }))),
    Check: forwardRef((props, ref) => {
        const classes = useStyles();
        return _jsx(Check, { ...props, className: classes.check, ref: ref });
    }),
    Clear: forwardRef((props, ref) => (_jsx(Clear, { ...props, ref: ref }))),
    Delete: forwardRef((props, ref) => (_jsx(DeleteOutline, { ...props, ref: ref }))),
    DetailPanel: forwardRef((props, ref) => (_jsx(ChevronRight, { ...props, ref: ref }))),
    Edit: forwardRef((props, ref) => (_jsx(Edit, { ...props, ref: ref }))),
    Export: forwardRef((props, ref) => (_jsx(SaveAlt, { ...props, ref: ref }))),
    Filter: forwardRef((props, ref) => (_jsx(FilterList, { ...props, ref: ref }))),
    FirstPage: forwardRef((props, ref) => (_jsx(FirstPage, { ...props, ref: ref }))),
    LastPage: forwardRef((props, ref) => (_jsx(LastPage, { ...props, ref: ref }))),
    NextPage: forwardRef((props, ref) => (_jsx(ChevronRight, { ...props, ref: ref }))),
    PreviousPage: forwardRef((props, ref) => (_jsx(ChevronLeft, { ...props, ref: ref }))),
    ResetSearch: forwardRef((props, ref) => (_jsx(Clear, { ...props, ref: ref }))),
    Search: forwardRef((props, ref) => (_jsx(Search, { ...props, ref: ref }))),
    SortArrow: forwardRef((props, ref) => (_jsx(ArrowUpward, { ...props, ref: ref }))),
    ThirdStateCheck: forwardRef((props, ref) => (_jsx(Remove, { ...props, ref: ref }))),
    ViewColumn: forwardRef((props, ref) => (_jsx(ViewColumn, { ...props, ref: ref })))
};
//# sourceMappingURL=tableIcons.js.map